import type { TPricingPlan } from "../types/enums";

export const LEGACY_KOTLIN_MEAL_PLAN_TO_PRICING_PLAN: Record<string, TPricingPlan> = {
  PlanTrial14x14: "TRIAL",
  Plan28x28: "STANDARD",
  Plan28x56: "HALF",
  Plan14x14: "FREEZER",
  Plan42x42: "SAVER",
  Plan7x7: "TRIAL_WEEK",
};

export const TRIAL_PLAN_DEFAULT_DISCOUNT = {
  discountCode: "FEED20",
  type: "ABSOLUTE_TOTAL",
  value: "20",
} as const;

export const TRIAL_WEEK_PLAN_DEFAULT_DISCOUNT = {
  discountCode: "FIXED_PRICE_SINGLE_10",
  type: "ABSOLUTE_TOTAL",
  value: "10",
} as const;

export const DIRECT_SALES_DEFAULT_DISCOUNT = {
  discountCode: "E-DS50",
  type: "PERCENTAGE",
  value: "50",
} as const;
